import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { AppRoutes } from '~/app/app.routes';
import { AuthService } from '~/service/service.auth';
import { PostCommentService } from '~/service/service.post.comment';
import { useService } from '~/shared/service/service.base';
import { Col, Row } from '../view.box';
import { LinkView } from '../view.link';
import { FeedbackDrawerItem, FeedbackDrawerTitle, FeedbackDrawerValue } from './feedback.drawer';
import { useFeedbackDrawerContext } from './feedback.drawer.ctx';

export const FeedbackDrawerComment = observer(() => {
	const { selectedItem, reloadList } = useFeedbackDrawerContext();
	const [postComment, auth] = useService(PostCommentService, AuthService);
	if (!selectedItem) return null;

	return (
		<Col gap={1}>
			<FeedbackDrawerItem>
				<FeedbackDrawerTitle>Complaint:</FeedbackDrawerTitle>
				<FeedbackDrawerValue>{selectedItem.complaint}</FeedbackDrawerValue>
			</FeedbackDrawerItem>
			<FeedbackDrawerItem>
				<FeedbackDrawerTitle>Post:</FeedbackDrawerTitle>
				<LinkView
					disabled={!auth.can('post', 'READ')}
					to={AppRoutes.PostEdit.buildPath({ id: selectedItem.postId ?? 0 })}
					target="_blank"
				>
					{selectedItem.postId}
				</LinkView>
			</FeedbackDrawerItem>
			<FeedbackDrawerItem>
				<FeedbackDrawerTitle>Post author:</FeedbackDrawerTitle>
				<LinkView
					disabled={!auth.can('user', 'READ')}
					to={AppRoutes.UserEdit.buildPath({ id: selectedItem?.postAuthorId ?? 0 })}
					target="_blank"
				>
					{selectedItem.postAuthor}
				</LinkView>
			</FeedbackDrawerItem>
			<FeedbackDrawerItem>
				<FeedbackDrawerTitle>Comment:</FeedbackDrawerTitle>
				<LinkView
					disabled={!auth.can('postComment', 'READ')}
					to={AppRoutes.PostEditCommentList.buildPath(
						{ id: selectedItem.postId ?? 0 },
						{ commentId: selectedItem.postCommentId ?? 0 },
					)}
					target="_blank"
				>
					{selectedItem.postCommentId}
				</LinkView>
			</FeedbackDrawerItem>
			<FeedbackDrawerItem>
				<FeedbackDrawerTitle>Comment author:</FeedbackDrawerTitle>
				<LinkView
					disabled={!auth.can('user', 'READ')}
					to={AppRoutes.UserEdit.buildPath({ id: selectedItem.postCommentAuthorId ?? 0 })}
					target="_blank"
				>
					{selectedItem.postCommentAuthor}
				</LinkView>
			</FeedbackDrawerItem>
			<FeedbackDrawerItem>
				<FeedbackDrawerTitle>Comment text:</FeedbackDrawerTitle>
				<FeedbackDrawerValue>{selectedItem.postCommentText}</FeedbackDrawerValue>
			</FeedbackDrawerItem>
			<FeedbackDrawerItem>
				<FeedbackDrawerTitle>Moderation:</FeedbackDrawerTitle>
				<FeedbackDrawerValue>{selectedItem.postCommentModeration}</FeedbackDrawerValue>
			</FeedbackDrawerItem>
			{selectedItem.postCommentAuthorId ? (
				<Row mt={2} gap={1}>
					{selectedItem?.postCommentModeration !== 'HIDDEN' ? (
						<Button
							fullWidth
							variant="contained"
							disabled={!auth.can('postComment', 'UPDATE')}
							onClick={() =>
								postComment.hide(selectedItem.postId, selectedItem.postCommentId).done(reloadList)
							}
						>
							Hide comment
						</Button>
					) : (
						<Button
							fullWidth
							variant="contained"
							disabled={!auth.can('postComment', 'UPDATE')}
							onClick={() =>
								postComment.approve(selectedItem.postId, selectedItem.postCommentId).done(reloadList)
							}
						>
							Approve comment
						</Button>
					)}

					<Button
						fullWidth
						variant="contained"
						color="warning"
						disabled={!auth.can('postComment', 'DELETE')}
						onClick={() =>
							postComment.delete(selectedItem.postId, selectedItem.postCommentId).done(reloadList)
						}
					>
						Delete comment
					</Button>
				</Row>
			) : null}
		</Col>
	);
});
